/**
 * Fime – Article single: "Read more" toggle for the sidebar author
 * bio (clamped to 4 lines by default). Also flips the chevron icon
 * and swaps the label text.
 *
 * Selector scoped to .article-author-readmore specifically — avoids
 * colliding with other modules (e.g. find-us-worldwide.js) that also
 * use a generic [data-toggle] attribute.
 */

document.querySelectorAll('.article-author-readmore[data-toggle]').forEach(function (btn) {
	btn.addEventListener('click', function () {
		const target = document.getElementById(btn.dataset.toggle);
		if (!target) return;

		const isExpanded = target.classList.toggle('is-expanded');
		btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

		const label = btn.querySelector('[data-toggle-label]');
		if (label) label.textContent = isExpanded ? 'Read less' : 'Read more';
	});
});
